import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash/fp'

export default class AnimatedSprite extends Component {
  static propTypes = {
    animate: PropTypes.bool,
    fps: PropTypes.number,
    loops: PropTypes.number,
    onComplete: PropTypes.func,
    srcs: PropTypes.arrayOf(PropTypes.string).isRequired,
    startFrame: PropTypes.number,
    unanimatedSrc: PropTypes.string,
    resetFramesOnStop: PropTypes.boolean,
  }

  static defaultProps = {
    animate: true,
    fps: 30,
    loops: Infinity,
    onComplete: () => {},
    startFrame: 0,
    resetFramesOnStop: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      frame: props.startFrame,
    }
  }

  getNextFrame() {
    const { frame } = this.state
    const { srcs } = this.props
    const numFrames = srcs.length

    let nextFrame = frame + 1
    if (nextFrame >= numFrames) nextFrame = 0

    return nextFrame
  }

  componentDidMount() {
    if (this.props.animate) this.startAnimation()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fps !== this.props.fps) {
      this.stopAnimation()
      this.startAnimation(nextProps.fps)
    }

    if (!this.props.animate && nextProps.animate) {
      this.startAnimation()
    } else if (this.props.animate && !nextProps.animate) {
      this.stopAnimation()
    }
  }

  componentWillUnmount() {
    this.stopAnimation()
  }

  startAnimation(fpsProvided) {
    const { srcs, fps, loops } = this.props
    const numFrames = srcs.length
    let loopCount = 0

    this.interval = setInterval(() => {
      if (loopCount >= loops) {
        this.stopAnimation()
        return
      }

      const nextFrame = this.getNextFrame()
      this.setState({ frame: nextFrame })

      if (nextFrame >= numFrames - 1) loopCount++
    }, 1000 / (fpsProvided || fps))
  }

  stopAnimation() {
    if (this.interval) clearInterval(this.interval)
    if (this.props.resetFramesOnStop)
      this.setState({ frame: this.props.startFrame })
    this.props.onComplete()
  }

  render() {
    const {
      onClick,
      animate,
      loops,
      srcs,
      fps,
      unanimatedSrc,
      startFrame,
      ...props
    } = this.props
    const src = animate ? srcs[this.frame] : unanimatedSrc || srcs[startFrame]

    return (
      <div onClick={onClick} {...props}>
        <img
          src={unanimatedSrc || srcs[startFrame]}
          style={{ display: animate ? 'none' : 'block' }}
        />
        {srcs.map((src, index) => (
          <img
            src={src}
            style={{
              display: animate && this.state.frame === index ? 'block' : 'none',
            }}
          />
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AnimatedSprite.js